<template>
  <div
    class="kpi-tree"
    :class="{ 'kpi-tree--scrolled': scrollTop > 0 }"
  >
    <!-- "Expandir tudo" e "Recolher" sairam: eram `setLevel(9)` e `setLevel(0)`,
         exatamente o "Tudo" e o "Resumo" da regua ao lado. Dois controles para a
         mesma acao, na barra mais disputada da tela. -->
    <div class="kpi-tree__toolbar">
      <div class="kpi-tree__toolbar-left">
        <span class="kpi-tree__level-label">Abrir até</span>
        <b-form-radio-group
          :checked="openLevel"
          size="sm"
          buttons
          button-variant="outline-secondary"
          class="kpi-tree__seg"
          :options="levelOptions"
          @change="setLevel"
        />

        <b-form-radio-group
          :checked="scope"
          size="sm"
          buttons
          button-variant="outline-secondary"
          class="kpi-tree__seg"
          :options="scopeOptions"
          @change="$emit('update:scope', $event)"
        />
      </div>
      <div class="kpi-tree__toolbar-right">
        <!-- LOCALIZAR. Nao e filtro: abre os pais, rola ate a pessoa e a destaca,
             sem esconder ninguem nem mudar total. O "Nome" do recorte fazia o
             contrario -- tirava as outras linhas da soma -- e ninguem que procura
             uma pessoa quer que o total mude por isso. -->
        <div
          class="kpi-tree__find"
          :class="{ 'kpi-tree__find--active': busca }"
        >
          <feather-icon
            icon="SearchIcon"
            size="14"
            class="kpi-tree__find-icon"
          />
          <input
            :value="busca"
            type="search"
            class="kpi-tree__find-input"
            placeholder="Localizar consultor"
            aria-label="Localizar consultor na árvore"
            @input="aoBuscar($event.target.value)"
            @keydown.enter.prevent="irPara($event.shiftKey ? -1 : 1)"
            @keydown.esc="limparBusca"
          >
          <template v-if="busca">
            <span class="kpi-tree__find-count">{{ rotuloDaBusca }}</span>
            <button
              type="button"
              class="kpi-tree__find-btn"
              aria-label="Resultado anterior"
              :disabled="!encontrados.length"
              @click="irPara(-1)"
            >
              <feather-icon
                icon="ChevronUpIcon"
                size="14"
              />
            </button>
            <button
              type="button"
              class="kpi-tree__find-btn"
              aria-label="Próximo resultado"
              :disabled="!encontrados.length"
              @click="irPara(1)"
            >
              <feather-icon
                icon="ChevronDownIcon"
                size="14"
              />
            </button>
            <button
              type="button"
              class="kpi-tree__find-btn"
              aria-label="Limpar busca"
              @click="limparBusca"
            >
              <feather-icon
                icon="XIcon"
                size="13"
              />
            </button>
          </template>
        </div>

        <slot name="toolbar" />

        <!-- EXIBICAO. O que so muda a VISTA mora aqui, e o que muda os NUMEROS
             mora no Recorte, la em cima. "So com movimento" e "Faturamento
             minimo" escondem linha sem mexer em total nenhum, e ficavam no
             mesmo painel que Solucao e Cargo, que mexem -- a pessoa nao tinha
             como saber quais dos dez campos mudavam a soma. -->
        <b-dropdown
          size="sm"
          :variant="exibicaoAtiva ? 'outline-primary' : 'outline-secondary'"
          right
          no-caret
          class="kpi-tree__exib"
          toggle-class="kpi-tree__exib-toggle"
        >
          <template #button-content>
            <feather-icon
              icon="SlidersIcon"
              size="14"
              class="mr-50"
            />
            Exibição
            <b-badge
              v-if="exibicaoAtiva"
              pill
              variant="primary"
              class="ml-50"
            >{{ exibicaoAtiva }}</b-badge>
          </template>
          <b-dropdown-form form-class="kpi-tree__exib-form">
            <div class="kpi-tree__exib-title">
              Linhas
              <feather-icon
                v-b-tooltip.hover.top="'Só escondem linhas da tabela. Totalizadores e o total da tabela ficam iguais.'"
                icon="InfoIcon"
                size="12"
                class="ml-25"
              />
            </div>
            <b-form-checkbox
              :checked="onlyWithMovement"
              switch
              @change="$emit('update:onlyWithMovement', $event)"
            >
              Só quem movimentou
            </b-form-checkbox>
            <label
              class="kpi-tree__exib-label"
              for="kpiTreeMinTotal"
            >Faturamento mínimo</label>
            <b-input-group
              size="sm"
              prepend="R$"
            >
              <b-form-input
                id="kpiTreeMinTotal"
                :value="minTotal"
                type="number"
                min="0"
                placeholder="0"
                aria-label="Faturamento mínimo"
                @input="aoMudarMinimo"
              />
            </b-input-group>

            <div class="kpi-tree__exib-sep" />

            <div class="kpi-tree__exib-title">
              Tabela
            </div>
            <b-form-radio-group
              :checked="density"
              size="sm"
              buttons
              button-variant="outline-secondary"
              class="kpi-tree__seg"
              :options="densityOptions"
              @change="$emit('update:density', $event)"
            />
            <b-form-checkbox
              :checked="showOutline"
              switch
              @change="$emit('update:showOutline', $event)"
            >
              Mostrar posição (1, 1.1, 1.2…)
            </b-form-checkbox>
          </b-dropdown-form>
        </b-dropdown>

        <b-button
          v-b-tooltip.hover.top="'Exportar CSV do que está na tela'"
          size="sm"
          variant="outline-secondary"
          class="btn-icon"
          aria-label="Exportar CSV do que está na tela"
          :disabled="loading || !visibleNodes.length"
          @click="exportCsv"
        >
          <feather-icon
            icon="DownloadIcon"
            size="14"
          />
        </b-button>
      </div>
    </div>

    <div
      ref="viewport"
      class="kpi-tree__viewport"
      :style="{ maxHeight: `${maxHeight}px` }"
      @scroll.passive="onScroll"
    >
      <table class="kpi-tree__table">
        <thead>
          <!-- A FAIXA DE MACROCOMPONENTE.
               Existe para dar assunto as colunas: com 13 rotulos de tres letras
               lado a lado, EA/PEF/EF/EP e R$ EP/R$ Assin. sao indistinguiveis
               sem ela. As cores nao sao decorativas -- sao as mesmas sete da
               tela antiga, entao quem ja usa o Faturometro reconhece o bloco
               antes de ler o rotulo. -->
          <tr
            ref="bandRow"
            class="kpi-tree__bands"
          >
            <th class="kpi-tree__band kpi-tree__band--identity kpi-tree__cell--identity" />
            <th
              v-for="band in columnBands"
              :key="band.key"
              class="kpi-tree__band"
              :class="{ 'kpi-tree__cell--pinned': band.pinned }"
              :colspan="band.span"
              :style="{
                '--band-tint': band.tint,
                '--band-ink': band.ink,
                '--band-base': band.base,
                '--band-ink-dark': band.inkDark,
              }"
            >{{ band.label }}</th>
          </tr>
          <tr
            ref="headRow"
            :style="{ '--kpi-tree-band-h': `${bandHeight}px` }"
          >
            <th class="kpi-tree__th kpi-tree__cell--identity">
              Consultor
            </th>
            <!-- Tooltip do Bootstrap, e nao `title`: o nativo leva um segundo
                 para aparecer, e e nesse segundo que a pessoa desiste de
                 descobrir o que e "PEF". -->
            <th
              v-for="column in colunasOrdenadas"
              :key="column.key"
              v-b-tooltip.hover.bottom="column.hint || column.label"
              class="kpi-tree__th kpi-tree__th--metric"
              :class="{ 'kpi-tree__cell--pinned': ehColunaObrigatoria(column.key) }"
            >
              {{ column.label }}
            </th>
          </tr>

          <!-- A LINHA DE TOTALIZACAO.
               Vive no <thead> e nao no <tbody> por duas razoes duras: a janela
               de rolagem mapeia posicao por floor(scrollTop / rowHeight), e uma
               linha de altura diferente ali desalinharia todas as outras; e a
               gaveta de detalhamento e fixed no rodape, entao um <tfoot> seria
               coberto justamente pelo clique principal desta tabela.

               A celula de identidade diz so "Total" e quantas linhas soma. O
               recorte (Propria / Equipe / Estrutura) estava escrito aqui num chip
               laranja, repetindo o controle que fica logo acima -- e o chip, o
               rotulo em caixa alta e a contagem em tres estilos eram o que fazia
               a linha nao assentar no cabecalho. O recorte continua no tooltip. -->
          <tr
            v-if="!loading && roots.length"
            class="kpi-tree__total"
            :style="{ '--kpi-tree-head-h': `${bandHeight + headHeight}px` }"
          >
            <th
              class="kpi-tree__cell kpi-tree__cell--identity"
              scope="row"
            >
              <span
                v-b-tooltip.hover.right="rotuloDoTotal"
                class="kpi-tree__total-label"
                tabindex="0"
              >Total</span>
              <b-badge
                variant="light-secondary"
                class="kpi-tree__count"
              >{{ contextCount }}</b-badge>
            </th>
            <td
              v-for="column in colunasOrdenadas"
              :key="column.key"
              class="kpi-tree__cell kpi-tree__cell--metric"
              :class="{
                'kpi-tree__cell--strong': ehColunaObrigatoria(column.key),
                'kpi-tree__cell--pinned': ehColunaObrigatoria(column.key),
                'kpi-tree__cell--zero': ehZero(column, contextTotals),
              }"
            >
              {{ format(column, contextTotals) }}
            </td>
          </tr>
        </thead>
        <tbody v-if="loading">
          <tr
            v-for="linha in skeletonRows"
            :key="`skeleton-${linha}`"
            class="kpi-tree__row kpi-tree__row--skeleton"
            :style="{ height: `${rowHeight}px` }"
          >
            <th class="kpi-tree__cell kpi-tree__cell--identity">
              <span
                class="kpi-tree__indent"
                :style="{ width: `${(linha % 3) * 18}px` }"
              />
              <span
                class="kpi-tree__shimmer"
                :style="{ width: `${120 + ((linha * 17) % 90)}px` }"
              />
            </th>
            <td
              v-for="column in colunasOrdenadas"
              :key="column.key"
              class="kpi-tree__cell kpi-tree__cell--metric"
              :class="{ 'kpi-tree__cell--pinned': ehColunaObrigatoria(column.key) }"
            >
              <span
                class="kpi-tree__shimmer kpi-tree__shimmer--metric"
                :style="{ width: `${38 + ((linha * 11) % 26)}px` }"
              />
            </td>
          </tr>
        </tbody>

        <tbody v-else>
          <tr
            v-if="padTop"
            class="kpi-tree__spacer"
            :style="{ height: `${padTop}px` }"
          >
            <td :colspan="columns.length + 1" />
          </tr>

          <tr
            v-for="node in windowNodes"
            :key="node.key"
            class="kpi-tree__row"
            :class="{
              'kpi-tree__row--selected': node.key === selectedKey,
              'kpi-tree__row--revealing': revealedFrom && node.parentKey === revealedFrom,
              'kpi-tree__row--found': encontradosSet.has(node.key),
              'kpi-tree__row--current': node.key === chaveAtual,
            }"
            :style="{ height: `${rowHeight}px`, '--kpi-reveal-index': indiceEntreIrmaos(node) }"
          >
            <th
              class="kpi-tree__cell kpi-tree__cell--identity"
              scope="row"
            >
              <span
                class="kpi-tree__indent"
                :style="{ width: `${node.depth * 18}px` }"
              />
              <button
                v-if="node.children.length"
                type="button"
                class="kpi-tree__toggle"
                :aria-expanded="expandedKeys.has(node.key) ? 'true' : 'false'"
                :aria-label="`${expandedKeys.has(node.key) ? 'Recolher' : 'Expandir'} ${node.name}`"
                @click="toggle(node)"
              >
                <feather-icon
                  icon="ChevronRightIcon"
                  size="14"
                  :class="{ 'kpi-tree__chevron--open': expandedKeys.has(node.key) }"
                  class="kpi-tree__chevron"
                />
              </button>
              <span
                v-else
                class="kpi-tree__toggle kpi-tree__toggle--leaf"
              />

              <span
                v-if="showOutline"
                class="kpi-tree__outline"
              >{{ node.outline }}</span>
              <span
                class="kpi-tree__name"
                :title="node.name"
              >{{ node.name }}</span>
              <span
                v-if="mostraFranquia(node)"
                class="kpi-tree__franchise"
                :title="rotuloDaFranquia(node)"
              >{{ rotuloDaFranquia(node) }}</span>
              <span
                v-if="node.roleName"
                class="kpi-tree__role"
                :class="`kpi-tree__role--${familiaDoCargo(node.roleName)}`"
                :title="node.roleName"
              >{{ node.roleName }}</span>
              <b-badge
                v-if="node.children.length"
                variant="light-secondary"
                class="kpi-tree__count"
              >{{ node.children.length }}</b-badge>
            </th>

            <td
              v-for="column in colunasOrdenadas"
              :key="column.key"
              class="kpi-tree__cell kpi-tree__cell--metric"
              :class="{
                'kpi-tree__cell--openable': abreGaveta(column, totalsOf(node)),
                'kpi-tree__cell--pinned': ehColunaObrigatoria(column.key),
              }"
              @click="openDetail(node, column, $event)"
            >
              <span
                class="kpi-tree__figure"
                :class="[
                  classeSemantica(column, totalsOf(node)),
                  { 'kpi-tree__figure--zero': ehZero(column, totalsOf(node)) },
                ]"
              >{{ format(column, totalsOf(node)) }}</span>
            </td>
          </tr>

          <tr
            v-if="padBottom"
            class="kpi-tree__spacer"
            :style="{ height: `${padBottom}px` }"
          >
            <td :colspan="columns.length + 1" />
          </tr>

          <tr
            v-if="!visibleNodes.length"
            class="kpi-tree__empty"
          >
            <td :colspan="columns.length + 1">
              <slot name="empty">
                Nenhum consultor no período e nos filtros escolhidos.
              </slot>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!--
      O trilho de componentes ocultos. Quatro dos oito blocos vêm desligados
      por padrão, e sem isto não há nada na tela dizendo que eles existem: o
      painel de Componentes só é descoberto por quem já sabe procurá-lo.
    -->
    <div
      v-if="componentesOcultos.length"
      class="kpi-tree__rail"
    >
      <span class="kpi-tree__rail-label">Componentes ocultos</span>
      <span
        v-for="grupo in componentesOcultos"
        :key="grupo.key"
        class="kpi-tree__rail-chip"
      >
        <span
          class="kpi-tree__rail-dot"
          :style="{ background: grupo.color }"
        />
        {{ grupo.label }}
        <span class="kpi-tree__rail-count">{{ grupo.quantas }} col</span>
      </span>
      <button
        type="button"
        class="kpi-tree__rail-cta"
        @click="$emit('show-columns')"
      >
        Exibir em Componentes
      </button>
    </div>

  </div>
</template>

<script>
import {
  BBadge, BButton, BDropdown, BDropdownForm, BFormCheckbox, BFormInput, BFormRadioGroup,
  BInputGroup, VBTooltip,
} from 'bootstrap-vue'
import {
  countContext, flattenVisible, keysUpToLevel, sumContext,
} from '../utils/kpiTree'
import {
  GROUPS, REQUIRED_COLUMN_KEYS, columnsByGroup, semAtribuicaoDeEspecialista,
} from '../utils/kpiColumns'

/** Grupo por chave, para a faixa nao varrer a lista a cada coluna. */
const GROUPS_BY_KEY = GROUPS.reduce((mapa, grupo) => ({ ...mapa, [grupo.key]: grupo }), {})

/** Sem acento e sem caixa: "joao" acha "João", que e como se digita com pressa. */
const normalizar = texto => String(texto || '')
  .normalize('NFD')
  .replace(/[̀-ͯ]/g, '')
  .toLowerCase()
  .trim()

/**
 * A tabela em árvore do Faturômetro.
 *
 * POR QUE HÁ JANELA DE ROLAGEM AQUI
 *
 * A tela antiga monta 2.687 linhas × 33 colunas de uma vez — ~88 mil células de
 * DOM num b-table sem virtualização. Medindo o caminho de leitura do backend, o
 * custo estava em 1,5s para a base inteira: saudável. O que sobra como
 * explicação para a tela ser sentida como lenta é o navegador. Por isso aqui só
 * existem no DOM as linhas visíveis mais uma margem.
 *
 * A janela exige altura de linha FIXA, e é isso que `rowHeight` garante. Linha
 * que cresce com o conteúdo desalinharia o cálculo e faria o scroll pular; o
 * nome longo é cortado com reticências de propósito.
 *
 * Não entrou biblioteca: com altura fixa a conta é um slice, e uma dependência
 * nova num branch de task tem raio de impacto maior que o problema que resolve.
 *
 * EXPANDIR TUDO NÃO TEM LIMITE — E TINHA, POR SUPOSIÇÃO MINHA
 *
 * Aqui havia `EXPAND_ALL_LIMIT = 500`, que desligava o botão com 2.701 nós, e
 * um aviso na tela dizendo "abrir tudo de uma vez trava a tela". Escrevi isso
 * ANTES da janela de rolagem existir e nunca voltei para medir.
 *
 * Medido, com os 2.701 nós de junho/2026:
 *
 *   expandir tudo e pintar        36 ms
 *   rolar (0, 20k, 60k, 100k px)  31, 37, 34, 36 ms
 *   linhas no DOM                 32, em qualquer um dos casos
 *
 * O custo não depende de quantos nós estão visíveis, porque o que vai para o
 * DOM é sempre a janela. O limite desligava o botão exatamente no caso em que
 * ele serve — a base grande — e o aviso afirmava um travamento que não existe.
 */

export default {
  name: 'KpiTreeTable',
  components: {
    BBadge, BButton, BDropdown, BDropdownForm, BFormCheckbox, BFormInput, BFormRadioGroup, BInputGroup,
  },
  directives: { 'b-tooltip': VBTooltip },
  props: {
    /** Raízes da árvore, de buildTree(). */
    roots: {
      type: Array,
      default: () => [],
    },
    /** Colunas resolvidas, de resolveColumns(). */
    columns: {
      type: Array,
      default: () => [],
    },
    /** Chave do nó com detalhamento aberto. */
    selectedKey: {
      type: String,
      default: null,
    },
    /**
     * Os três recortes que o §27 pede lado a lado:
     *
     *   own      só o consultor
     *   direct   ele mais quem responde diretamente a ele
     *   network  a estrutura inteira abaixo
     *
     * Um líder que vende bem e lidera mal some dentro do subtotal da estrutura,
     * e um que lidera bem e não vende também. É a distinção que a tela antiga
     * nunca mostrou, porque agrupava por franquia e não tinha nó de líder.
     */
    scope: {
      type: String,
      default: 'network',
    },
    /**
     * Prefixa a linha com a posição dela na árvore — 1, 1.1, 1.1.2.
     *
     * Desligado por padrão, e o rótulo diz "Posição" e não "Código": o número é
     * derivado do que está na tela e muda quando o filtro muda. Serve para uma
     * pessoa apontar uma linha para outra na mesma tela, não para identificar
     * ninguém fora dela.
     */
    showOutline: {
      type: Boolean,
      default: false,
    },
    rowHeight: {
      type: Number,
      default: 40,
    },
    maxHeight: {
      type: Number,
      default: 620,
    },
    /**
     * Enquanto carrega, o corpo vira esqueleto — mas o cabeçalho e as colunas
     * continuam os de verdade. O esqueleto só serve se tiver a forma do que vai
     * chegar; um spinner centralizado troca a tela por um vazio e faz a volta
     * do conteúdo parecer um salto.
     */
    loading: {
      type: Boolean,
      default: false,
    },
    /**
     * Nós escondidos por filtro de EXIBIÇÃO. A subárvore inteira sai junto, e
     * nenhum total muda — ver kpiFilters.js.
     */
    /** Qual leitura esta na tela: muda o que e `—` e o que e `0`. */
    perspective: {
      type: String,
      default: 'owner',
    },
    hiddenKeys: {
      type: Set,
      default: () => new Set(),
    },
    /** Linhas renderizadas fora da vista, de cada lado. Amortece o scroll. */
    overscan: {
      type: Number,
      default: 8,
    },
    /**
     * Os dois filtros de EXIBICAO, que moram na view (em `criteria`, e por isso
     * na URL) mas sao editados aqui, no menu Exibicao da barra da tabela.
     */
    onlyWithMovement: {
      type: Boolean,
      default: false,
    },
    minTotal: {
      type: [Number, String],
      default: null,
    },
    /** 'confortavel' (40px) ou 'compacta' (32px). A view traduz em rowHeight. */
    density: {
      type: String,
      default: 'confortavel',
    },
    /** Nome do arquivo do CSV, sem extensão. A view sabe o período. */
    exportName: {
      type: String,
      default: 'faturometro',
    },
  },
  data() {
    return {
      busca: '',
      buscaIdx: 0,
      expandedKeys: new Set(),
      // Quantas camadas ficam abertas. -1 = o usuario mexeu num chevron a mao,
      // e af nenhum degrau da regua fica aceso, porque nenhum descreve a tela.
      openLevel: 1,
      headHeight: 32,
      // 24 e a altura real medida da faixa. O 26 anterior era chute para cima,
      // e chute para cima e exatamente o que abre a fresta ate measure() rodar.
      bandHeight: 24,
      scrollTop: 0,
      viewportHeight: 0,
      // Chave do nó que acabou de ser aberto. As filhas dele entram com um
      // fade curto e escalonado; depois a marca sai e a tabela volta a ser
      // estática — animar linha durante scroll é o caminho mais rápido para a
      // tela engasgar.
      revealedFrom: null,
    }
  },
  computed: {
    visibleNodes() {
      return flattenVisible(this.roots, this.expandedKeys, this.hiddenKeys)
    },
    byKeyLocal() {
      const porChave = new Map()
      const stack = [...this.roots]
      while (stack.length) {
        const node = stack.pop()
        porChave.set(node.key, node)
        node.children.forEach(child => stack.push(child))
      }
      return porChave
    },
    /**
     * Os consultores que aparecem em MAIS DE UMA linha.
     *
     * A chave do no e `consultor:franquia` (kpiTree.js rowKey), entao quem
     * fatura em mais de uma franquia tem um no por franquia. Sem nada que as
     * distinga, duas linhas do mesmo consultor ficam com nome e cargo
     * IDENTICOS e numeros diferentes, uma embaixo da outra.
     *
     * So esses ganham o chip: com uma linha so ele seria ruido.
     *
     * Sai do byKeyLocal, que ja varre a arvore inteira, e NAO de visibleNodes:
     * derivar do que esta expandido faria o chip piscar ao abrir e fechar.
     */
    consultoresRepetidos() {
      const vistos = new Set()
      const repetidos = new Set()
      this.byKeyLocal.forEach(node => {
        if (vistos.has(node.consultantId)) {
          repetidos.add(node.consultantId)
          return
        }
        vistos.add(node.consultantId)
      })
      return repetidos
    },
    /**
     * O total do CONTEXTO — o que a linha de totalizacao mostra.
     *
     * As raizes ja chegam RECORTADAS pelo botao (a view aplica scopeRoots), e
     * aqui a soma e sempre a producao PROPRIA de todo mundo que esta na lista.
     * E isso que a mantem coerente com a tabela: uma celula recolhida mostra a
     * subarvore somada e uma expandida mostra so a propria, mas a SOMA do que
     * esta na tela e a mesma nos dois casos, porque expandir redistribui em vez
     * de criar.
     */
    contextTotals() {
      return sumContext(this.roots, 'network')
    },
    /** Quantas linhas o recorte abrange. Era o "Consultores" da tira de cima. */
    contextCount() {
      return countContext(this.roots, 'network')
    },
    /**
     * As colunas visiveis agrupadas em CORRIDAS consecutivas de macrocomponente.
     *
     * Corrida, e nao grupo: o usuario escolhe as colunas no painel de
     * Componentes e pode deixar Funil, depois Producao, depois Funil de novo.
     * Um colspan por grupo assumiria que cada grupo e contiguo e desalinharia a
     * faixa inteira. Aqui cada trecho contiguo vira sua propria celula, e um
     * grupo repetido aparece duas vezes -- que e a verdade do que esta na tela.
     */
    columnBands() {
      const faixas = []

      this.colunasRolaveis.forEach(column => {
        const grupo = GROUPS_BY_KEY[column.group]
        const ultima = faixas[faixas.length - 1]

        if (ultima && ultima.key === column.group) {
          ultima.span += 1
          return
        }

        faixas.push({
          key: column.group,
          // A chave do v-for precisa ser unica quando o grupo se repete.
          label: grupo ? grupo.label : '',
          span: 1,
          tint: grupo ? grupo.tint : 'transparent',
          ink: grupo ? grupo.ink : 'inherit',
          base: grupo ? grupo.base : 'transparent',
          inkDark: grupo ? grupo.inkDark : 'inherit',
        })
      })

      // A coluna fixa ganha faixa propria: dentro da corrida de "Resumos de
      // faturamento" ela nao poderia grudar sozinha na direita.
      if (this.colunaFixa) {
        const grupo = GROUPS_BY_KEY[this.colunaFixa.group]
        faixas.push({
          key: 'fixa',
          label: 'Total',
          span: 1,
          pinned: true,
          tint: grupo ? grupo.tint : 'transparent',
          ink: grupo ? grupo.ink : 'inherit',
          base: grupo ? grupo.base : 'transparent',
          inkDark: grupo ? grupo.inkDark : 'inherit',
        })
      }

      return faixas.map((faixa, indice) => ({ ...faixa, key: `${faixa.key}-${indice}` }))
    },
    /**
     * A COLUNA DE TOTAL FICA NA DIREITA, FIXA.
     *
     * Com 29 colunas ligadas, "R$ Total" -- a unica que nao se pode desligar, e
     * a razao de a tela existir -- ficava cortada na borda ("R$ TO…") e so
     * aparecia rolando tudo para o lado. Agora ela sai da ordem do catalogo e
     * gruda na borda direita, espelhando a coluna de nomes na esquerda: rola-se
     * o meio, e as duas pontas que dao sentido a linha ficam paradas.
     */
    colunaFixa() {
      return this.columns.find(column => REQUIRED_COLUMN_KEYS.includes(column.key)) || null
    },
    colunasRolaveis() {
      return this.columns.filter(column => !REQUIRED_COLUMN_KEYS.includes(column.key))
    },
    colunasOrdenadas() {
      return this.colunaFixa ? [...this.colunasRolaveis, this.colunaFixa] : this.colunasRolaveis
    },
    /** O rotulo do recorte ativo, para a linha dizer de QUE total ela fala. */
    scopeLabel() {
      const opcao = this.scopeOptions.find(item => item.value === this.scope)
      return opcao ? opcao.text : ''
    },
    rotuloDoTotal() {
      const linhas = this.contextCount === 1 ? 'linha' : 'linhas'
      return `Soma de ${this.scopeLabel} · ${this.contextCount} ${linhas}. `
        + 'Cada pessoa conta uma vez, pela produção própria.'
    },
    /** Todos os nós na ordem da árvore — a ordem em que o Localizar percorre. */
    todosEmOrdem() {
      const lista = []
      const visitar = nos => nos.forEach(node => {
        lista.push(node)
        visitar(node.children)
      })
      visitar(this.roots)
      return lista
    },
    /** As chaves que casam com a busca, na ordem da árvore. Menos de 2 letras não busca. */
    encontrados() {
      const termo = normalizar(this.busca)
      if (termo.length < 2) {
        return []
      }
      return this.todosEmOrdem
        .filter(node => normalizar(node.name).includes(termo))
        .map(node => node.key)
    },
    encontradosSet() {
      return new Set(this.encontrados)
    },
    chaveAtual() {
      const total = this.encontrados.length
      if (!total) {
        return null
      }
      return this.encontrados[((this.buscaIdx % total) + total) % total]
    },
    rotuloDaBusca() {
      const total = this.encontrados.length
      if (!total) {
        return normalizar(this.busca).length < 2 ? '' : 'nenhum'
      }
      return `${(((this.buscaIdx % total) + total) % total) + 1} de ${total}`
    },
    /** Quantos filtros de exibição estão ligados — o número no botão. */
    exibicaoAtiva() {
      const minimo = Number(this.minTotal)
      return (this.onlyWithMovement ? 1 : 0) + (Number.isFinite(minimo) && minimo > 0 ? 1 : 0)
    },
    densityOptions() {
      return [
        { value: 'confortavel', text: 'Confortável' },
        { value: 'compacta', text: 'Compacta' },
      ]
    },
    skeletonRows() {
      // O suficiente para encher a área visível, não mais: cada linha falsa é
      // DOM de verdade.
      return Array.from({ length: Math.ceil(this.maxHeight / this.rowHeight) }, (_, i) => i + 1)
    },
    scopeOptions() {
      // Os três recortes do §27: o líder sozinho, o líder mais quem responde a
      // ele, e a estrutura inteira abaixo.
      return [
        { value: 'own', text: 'Própria' },
        { value: 'direct', text: 'Equipe direta' },
        { value: 'network', text: 'Estrutura' },
      ]
    },
    /**
     * A régua do protótipo. `Tudo` é 9 e não Infinity porque o valor vai para
     * um radio-group, que compara por igualdade — e nenhuma estrutura real tem
     * nove níveis de liderança.
     */
    /**
     * Os blocos inteiramente desligados, para o trilho.
     *
     * Bloco PARCIALMENTE ligado não entra: ele já está visível na faixa
     * colorida do cabeçalho, e listá-lo como 'oculto' seria mentira.
     */
    componentesOcultos() {
      const visiveis = new Set(this.columns.map(coluna => coluna.group))

      return columnsByGroup()
        .filter(grupo => grupo.columns.length && !visiveis.has(grupo.key))
        .map(grupo => ({
          key: grupo.key, label: grupo.label, color: grupo.base, quantas: grupo.columns.length,
        }))
    },
    levelOptions() {
      return [
        { text: 'Resumo', value: 0 },
        { text: '1', value: 1 },
        { text: '2', value: 2 },
        { text: '3', value: 3 },
        { text: 'Tudo', value: 9 },
      ]
    },
    windowStart() {
      const first = Math.floor(this.scrollTop / this.rowHeight) - this.overscan
      return Math.max(0, first)
    },
    windowEnd() {
      const fit = Math.ceil((this.viewportHeight || this.maxHeight) / this.rowHeight)
      return Math.min(this.visibleNodes.length, this.windowStart + fit + this.overscan * 2)
    },
    windowNodes() {
      return this.visibleNodes.slice(this.windowStart, this.windowEnd)
    },
    padTop() {
      return this.windowStart * this.rowHeight
    },
    padBottom() {
      return Math.max(0, (this.visibleNodes.length - this.windowEnd) * this.rowHeight)
    },
  },
  watch: {
    roots() {
      // Recorte novo: a árvore mudou de forma, e manter expandido o que sumiu
      // deixaria o scroll num lugar que não existe mais.
      this.setLevel(this.openLevel < 0 ? 1 : this.openLevel)
      this.resetScroll()
      // Uma busca em andamento sobrevive à recarga: a pessoa procurada continua
      // aberta e destacada, e não some porque o período mudou.
      if (this.encontrados.length) {
        this.$nextTick(() => this.revelarEncontrados())
      }
    },
  },
  mounted() {
    this.setLevel(this.openLevel < 0 ? 1 : this.openLevel)
    this.measure()
    window.addEventListener('resize', this.measure)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.measure)
    if (this.revealTimer) {
      clearTimeout(this.revealTimer)
    }
  },
  methods: {
    measure() {
      const { viewport, headRow, bandRow } = this.$refs
      this.viewportHeight = viewport ? viewport.clientHeight : this.maxHeight
      // floor, e nao round: estes dois numeros viram o `top` de quem gruda
      // LOGO ABAIXO. Arredondar para cima cria uma fresta de ate 1px entre a
      // faixa e o cabecalho -- e como o `background` do cabecalho so comeca no
      // `top`, essa fresta e transparente e a linha do corpo aparece por ela ao
      // rolar. Errar para menos so sobrepoe, e sobrepor e invisivel porque quem
      // esta em cima tem z-index maior.
      if (bandRow) {
        this.bandHeight = Math.floor(bandRow.getBoundingClientRect().height)
      }
      // A linha de total gruda LOGO ABAIXO do cabecalho, e esse offset nao pode
      // ser cravado: muda com zoom, com a fonte e com o padding do celular.
      if (headRow) {
        this.headHeight = Math.floor(headRow.getBoundingClientRect().height)
      }
    },
    onScroll(event) {
      this.scrollTop = event.target.scrollTop
    },
    resetScroll() {
      this.scrollTop = 0
      this.$nextTick(() => {
        if (this.$refs.viewport) {
          this.$refs.viewport.scrollTop = 0
        }
        this.measure()
      })
    },
    toggle(node) {
      // Mexeu a mão: nenhum degrau da régua descreve a tela, então nenhum fica
      // aceso. Acender um seria dizer que a árvore está num estado que não está.
      this.openLevel = -1
      // Set novo a cada troca: o Vue 2 não é reativo a Set mutado no lugar.
      const next = new Set(this.expandedKeys)
      const abrindo = !next.has(node.key)

      if (abrindo) {
        next.add(node.key)
      } else {
        next.delete(node.key)
      }

      this.expandedKeys = next
      this.marcarRevelacao(abrindo ? node.key : null)
    },
    /**
     * Marca quem acabou de ser revelado, e desmarca sozinho.
     *
     * A marca precisa sair: sem isso, rolar a tabela faria linhas antigas
     * reentrarem animando a cada reciclagem da janela.
     */
    marcarRevelacao(key) {
      if (this.revealTimer) {
        clearTimeout(this.revealTimer)
        this.revealTimer = null
      }

      this.revealedFrom = key

      if (!key) {
        return
      }

      this.revealTimer = setTimeout(() => {
        this.revealedFrom = null
        this.revealTimer = null
      }, 520)
    },
    /** Posição entre os irmãos, para o fade entrar escalonado. */
    indiceEntreIrmaos(node) {
      if (!this.revealedFrom || node.parentKey !== this.revealedFrom) {
        return 0
      }
      const pai = this.byKeyLocal.get(node.parentKey)
      if (!pai) {
        return 0
      }
      // Teto baixo: escalonar 200 irmãos faria o último aparecer segundos
      // depois do primeiro, e o que era polimento vira lentidão.
      return Math.min(pai.children.indexOf(node), 7)
    },
    /**
     * Abre a árvore até `nivel` — a régua do §27.
     *
     * Substitui o par tudo-ou-nada: numa estrutura de sete níveis, `Expandir
     * tudo` não é leitura, é despejo, e some com a linha que a pessoa estava
     * lendo. Os extremos são o "Resumo" e o "Tudo" da própria régua.
     */
    setLevel(nivel) {
      this.openLevel = nivel
      this.expandedKeys = keysUpToLevel(this.roots, nivel)
      this.marcarRevelacao(null)
      this.resetScroll()
    },

    // ---- Localizar ---------------------------------------------------------
    aoBuscar(valor) {
      this.busca = valor
      this.buscaIdx = 0
      this.revelarEncontrados()
    },
    /**
     * Abre os pais de TODOS os encontrados e rola até o atual.
     *
     * Todos, e não só o atual: o Enter percorre os resultados, e cada um que
     * estivesse dentro de um nó fechado seria um "3 de 5" que não aparece na
     * tela. Mexer nos chevrons é o mesmo que mexer à mão, então a régua apaga.
     */
    revelarEncontrados() {
      if (!this.encontrados.length) {
        return
      }
      const abertos = new Set(this.expandedKeys)
      this.encontrados.forEach(chave => {
        let node = this.byKeyLocal.get(chave)
        while (node && node.parentKey) {
          abertos.add(node.parentKey)
          node = this.byKeyLocal.get(node.parentKey)
        }
      })
      if (abertos.size !== this.expandedKeys.size) {
        this.expandedKeys = abertos
        this.openLevel = -1
      }
      this.$nextTick(() => this.rolarAte(this.chaveAtual))
    },
    irPara(passo) {
      if (!this.encontrados.length) {
        return
      }
      this.buscaIdx += passo
      this.$nextTick(() => this.rolarAte(this.chaveAtual))
    },
    limparBusca() {
      this.busca = ''
      this.buscaIdx = 0
    },
    /**
     * Põe a linha no terço de cima da janela da tabela.
     *
     * Um nó escondido por Exibição ("só quem movimentou") não está em
     * visibleNodes: ele é destacado como encontrado mas não há onde rolar.
     */
    rolarAte(chave) {
      const { viewport } = this.$refs
      const indice = this.visibleNodes.findIndex(node => node.key === chave)
      if (!viewport || indice < 0) {
        return
      }
      const alvo = Math.max(0, (indice * this.rowHeight) - (viewport.clientHeight / 3))
      viewport.scrollTop = alvo
      this.scrollTop = alvo
    },

    aoMudarMinimo(valor) {
      const numero = valor === '' || valor === null ? null : Number(valor)
      this.$emit('update:minTotal', Number.isFinite(numero) && numero > 0 ? numero : null)
    },

    /**
     * O CSV do que está NA TELA.
     *
     * Linhas visíveis, na ordem e no estado do acordeão: um nó recolhido sai com
     * o subtotal da subestrutura, como a célula mostra. As colunas são as ligadas
     * em Componentes, com o total primeiro. Ponto-e-vírgula e vírgula decimal
     * porque quem abre é o Excel em português, e o BOM é o que faz o acento
     * chegar inteiro.
     */
    exportCsv() {
      const separador = ';'
      const numero = valor => (Number.isFinite(valor)
        ? String(Math.round(valor * 100) / 100).replace('.', ',')
        : '')
      const texto = valor => {
        const bruto = String(valor === null || valor === undefined ? '' : valor)
        return /[;"\r\n]/.test(bruto) ? `"${bruto.replace(/"/g, '""')}"` : bruto
      }
      const colunas = this.colunasOrdenadas
      const valores = totais => colunas.map(column => (this.semAtribuicao(column)
        ? ''
        : numero(column.value(totais))))

      const linhas = [
        ['Posição', 'Consultor', 'Cargo', 'Franquia', 'Nível', ...colunas.map(column => column.label)]
          .map(texto).join(separador),
        ['', texto(`Total (${this.scopeLabel})`), '', '', '', ...valores(this.contextTotals)].join(separador),
        ...this.visibleNodes.map(node => [
          texto(node.outline),
          texto(node.name),
          texto(node.roleName),
          texto(node.leaderFranchiseName),
          node.depth,
          ...valores(this.totalsOf(node)),
        ].join(separador)),
      ]

      const blob = new Blob([String.fromCharCode(0xFEFF), linhas.join('\r\n')], { type: 'text/csv;charset=utf-8;' })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = `${this.exportName}.csv`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
    /**
     * Quem abre a gaveta. UMA regra, consultada pelo visual E pelo clique.
     *
     * Antes o `<td>` pintava a afordancia checando `semAtribuicao` e o
     * `openDetail` nao checava — os dois so concordavam por acidente, porque
     * nenhuma coluna sem atribuicao tinha `detailBucket`. Bastava alguem
     * acrescentar uma para a celula ficar morta ao olho e viva ao clique.
     *
     * Valor ZERO nao abre: uma gaveta vazia nao ensina nada e a promessa do
     * painel e "estes sao os contratos que compoem este numero". Sem numero,
     * nao ha o que compor — e e o que o design faz, trocando o link pela
     * classe `.zero`.
     */
    abreGaveta(column, totals) {
      return !!column.detailBucket
        && !this.semAtribuicao(column)
        && !this.ehZero(column, totals)
    },
    /** Zero de verdade — nao "—", que e ausencia de atribuicao. */
    ehZero(column, totals) {
      if (this.semAtribuicao(column)) {
        return false
      }
      const valor = column.value(totals)
      return Number.isFinite(valor) && valor === 0
    },
    /**
     * A familia do cargo, para o chip ter cor.
     *
     * Os cargos reais sao PNH, PNP, PNC, PNF, PNM 1, FA, FE, FF, FR, FO, FC e
     * "Futuro Indica" -- e nao os cinco rotulos do desenho (FE / ESPECIALISTA /
     * PROPRIO / FOUNDER / PN), que eram nomes de prancheta. O que o desenho
     * queria distinguir e a FAMILIA: franqueado x PN x fundador. E isso que o
     * prefixo ja diz, entao a regra e o prefixo e nao uma lista que envelhece a
     * cada cargo novo.
     *
     * ESPECIALISTA nao entra: na tela nova a perspectiva troca a tabela
     * inteira, entao TODA linha seria "especialista" e o selo nao separaria
     * nada. No desenho ele marcava linha a linha porque as duas leituras
     * conviviam na mesma tabela, e elas nao convivem mais.
     */
    /** O chip de franquia so aparece quando ele desambigua duas linhas iguais. */
    mostraFranquia(node) {
      return this.consultoresRepetidos.has(node.consultantId)
    },
    /**
     * O rotulo da franquia na linha.
     *
     * As linhas sem `leader_franchise_name` chegam com string vazia, e chip
     * vazio e pior que chip nenhum: o id e feio, mas distingue, que e a unica
     * coisa que este chip existe para fazer.
     */
    rotuloDaFranquia(node) {
      return node.leaderFranchiseName || `Franquia ${node.digitalFranchiseId}`
    },
    familiaDoCargo(roleName) {
      const nome = String(roleName || '').trim().toUpperCase()
      if (nome === 'FO') {
        return 'fundador'
      }
      if (nome.startsWith('PN')) {
        return 'pn'
      }
      if (nome.startsWith('F')) {
        return 'franqueado'
      }
      return 'outro'
    },
    /**
     * A cor que o NUMERO carrega, quando ele tem significado.
     *
     * Duas so: o total em verde, porque e a leitura de cabeceira; e o percentual
     * em verde/cinza/vermelho pelos cortes do desenho (70% e 45%). Todas as
     * colunas de percentual sao taxa de CONVERSAO -- EA/EF, EF/EP, EA/EP,
     * MXA/MXF, MXF/MXC, PA/PF, PF/PC -- entao "maior e melhor" vale para as
     * sete e um corte so serve.
     */
    classeSemantica(column, totals) {
      if (column.key === 'total_contract_amount') {
        return 'kpi-tree__figure--total'
      }
      if (column.type !== 'percent' || this.semAtribuicao(column)) {
        return null
      }
      const valor = column.value(totals)
      if (!Number.isFinite(valor) || valor === 0) {
        return null
      }
      if (valor >= 70) {
        return 'kpi-tree__figure--alto'
      }
      return valor >= 45 ? null : 'kpi-tree__figure--baixo'
    },
    /** A coluna que nao se pode tirar ganha destaque na linha de total. */
    ehColunaObrigatoria(key) {
      return REQUIRED_COLUMN_KEYS.includes(key)
    },
    /**
     * O que a celula mostra: RECOLHIDO soma, EXPANDIDO separa.
     *
     * Um no fechado exibe o total da subestrutura dele — ele mais todos abaixo.
     * Ao abrir, a linha dele passa a mostrar so a producao propria e os filhos
     * aparecem com as deles. A soma do que esta na tela e a mesma nos dois
     * estados, porque expandir redistribui em vez de criar.
     *
     * E o que torna desnecessario o numero empilhado que existia aqui: o estado
     * do acordeao ja diz qual dos dois numeros se esta lendo. O recorte
     * (Propria / Equipe direta / Estrutura) nao entra nesta conta: ele decide
     * QUEM esta na lista, e isso a view ja resolveu com scopeRoots.
     */
    totalsOf(node) {
      if (!node.children.length) {
        return node.own
      }

      return this.expandedKeys.has(node.key) ? node.own : node.totals
    },
    format(column, totals) {
      if (this.semAtribuicao(column)) {
        return '—'
      }

      const value = column.value(totals)

      if (!Number.isFinite(value)) {
        // Acontece de verdade: MXF/MXC divide por zero quando há Momento X
        // agendado e nenhum feito. O defeito é herdado da tela antiga de
        // propósito (ver kpiColumns.js); o que não se herda é mostrar a palavra
        // "Infinity" para o usuário.
        return '—'
      }

      if (column.type === 'money') {
        return this.$options.filters.toCurrency(value)
      }
      if (column.type === 'percent') {
        return this.$options.filters.toPercentage(value)
      }
      if (column.type === 'decimal') {
        return this.$options.filters.toDecimal(value)
      }
      return value
    },
    /**
     * `—` quando a coluna nao tem atribuicao nesta leitura.
     *
     * Vale so na perspectiva de especialista, e so para as colunas que o backend
     * nao sabe atribuir. Mostrar `0` ali diria "nao produziu" onde a verdade e
     * "nao e medido".
     */
    semAtribuicao(column) {
      return this.perspective === 'specialist' && semAtribuicaoDeEspecialista(column.key)
    },
    openDetail(node, column, evento) {
      if (!this.abreGaveta(column, this.totalsOf(node))) {
        return
      }
      this.$emit('cell-click', { node, column, bucket: column.detailBucket })
      this.manterLinhaVisivel(evento)
    },
    /**
     * A linha clicada não pode ficar embaixo da gaveta.
     *
     * A gaveta é fixed no rodapé e ocupa até 52% da altura: clicar numa linha
     * da metade de baixo abria o detalhamento POR CIMA da própria linha, e a
     * pessoa perdia de vista de onde veio o número. Se ela está na zona que a
     * gaveta vai cobrir, a página sobe o suficiente para ela ficar logo acima.
     */
    manterLinhaVisivel(evento) {
      const celula = evento && evento.currentTarget
      const linha = celula && celula.closest ? celula.closest('tr') : null
      if (!linha) {
        return
      }
      this.$nextTick(() => {
        const limite = (window.innerHeight * 0.48) - 16
        const { bottom } = linha.getBoundingClientRect()
        if (bottom > limite) {
          window.scrollBy({ top: bottom - limite, behavior: 'smooth' })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
/* A LINHA DE TOTALIZACAO — 2a linha do <thead>, grudada sob o cabecalho.
   O fundo OPACO e requisito e nao estetica: celula sticky translucida deixa a
   linha de baixo aparecer atraves dela. Usa o MESMO fundo do cabecalho para os
   dois lerem como um bloco fixo so: rotulo pequeno em cima, numero grande
   embaixo, como legenda e valor.
   O filete laranja de 2px saiu. Era ele, mais o chip e a caixa alta, que
   separavam a linha do cabecalho em vez de assenta-la nele. O fim do bloco e
   um filete de 1px, e a sombra so aparece quando ha linha passando por baixo
   (.kpi-tree--scrolled). */
.kpi-tree__total > .kpi-tree__cell {
  position: sticky;
  /* Mesma regra da fresta do cabecalho: -1px, e o fallback e faixa + cabecalho
     (24 + 32), nao so o cabecalho. */
  top: calc(var(--kpi-tree-head-h, 56px) - 1px);
  z-index: 3;
  height: 42px;
  padding-bottom: 2px;
  background: var(--kpi-tree-head-bg, #f3f2f7);
  border-bottom: 1px solid var(--kpi-line-strong, #d8d6e0);
  font-weight: 600;
  font-size: 0.964rem;
  color: var(--kpi-tree-total-fg, #5e5873);
  white-space: nowrap;
  transition: box-shadow 160ms ease;
}

.kpi-tree--scrolled .kpi-tree__total > .kpi-tree__cell {
  box-shadow: 0 8px 10px -8px var(--kpi-tree-sticky-shadow, rgba(34, 41, 47, 0.25));
}

/* Zero no total se apaga como no corpo: "0" e "R$ 0,00" em negrito branco
   competiam com os numeros que valem alguma coisa. */
.kpi-tree__total > .kpi-tree__cell.kpi-tree__cell--zero {
  font-weight: 500;
  color: var(--kpi-tree-zero, #d5d3de);
}

/* O rotulo da coluna fica colado no numero de baixo. */
.kpi-tree__th--metric {
  padding-bottom: 0.2rem;
}

.kpi-tree__total > .kpi-tree__cell--metric {
  text-align: right;
  font-variant-numeric: tabular-nums;
}

/* A coluna obrigatoria e a leitura principal. O verde e o do "Estrutura
   completa" do canvas (.m-tot { color: var(--kpi-positive, #197b44) }). */
.kpi-tree__total > .kpi-tree__cell--strong {
  color: var(--kpi-tree-total-strong, #197b44);
}

/* Sticky nos dois eixos: o vertical vem do `top` acima, o horizontal daqui. */
.kpi-tree__total > .kpi-tree__cell--identity {
  left: 0;
  z-index: 4;
  text-align: left;
}

.kpi-tree__total-label {
  margin-left: 24px; /* largura do chevron: alinha "Total" com o nome das raizes */
  font-size: 0.929rem;
  font-weight: 600;
  vertical-align: middle;
  cursor: help;
  outline: none;
}

.kpi-tree__total-label:focus-visible {
  text-decoration: underline;
  text-underline-offset: 3px;
}

/* ---------------------------------------------------------------------------
   A COLUNA FIXA (R$ Total), grudada na direita — o espelho da coluna de nomes.
   Mesma escada de z-index da identidade: corpo 1, total 4, cabecalho 6,
   faixa 7. O fundo e opaco pelo mesmo motivo de la.
   --------------------------------------------------------------------------- */
.kpi-tree__cell--pinned {
  position: sticky;
  right: 0;
  z-index: 1;
  background: var(--kpi-tree-cell-bg, #fff);
  box-shadow:
    inset 1px 0 0 var(--kpi-line-strong, #ebe9f1),
    -10px 0 12px -10px var(--kpi-tree-pin-shadow, rgba(34, 41, 47, 0.2));
}

.kpi-tree__total > .kpi-tree__cell--pinned {
  z-index: 4;
  background: var(--kpi-tree-head-bg, #f3f2f7);
}

.kpi-tree--scrolled .kpi-tree__total > .kpi-tree__cell--pinned {
  box-shadow:
    inset 1px 0 0 var(--kpi-line-strong, #ebe9f1),
    -10px 0 12px -10px var(--kpi-tree-pin-shadow, rgba(34, 41, 47, 0.2)),
    0 8px 10px -8px var(--kpi-tree-sticky-shadow, rgba(34, 41, 47, 0.25));
}

.kpi-tree__th.kpi-tree__cell--pinned {
  z-index: 6;
  background: var(--kpi-tree-head-bg, #f3f2f7);
}

.kpi-tree__band.kpi-tree__cell--pinned {
  z-index: 7;
}

/* ---------------------------------------------------------------------------
   Controles segmentados: a opcao ativa PREENCHIDA.
   O outline-secondary do template marca o ativo com um cinza quase igual ao
   repouso, e na regua "Resumo 1 2 3 Tudo" nao dava para ver em que nivel a
   arvore estava. Laranja cheio e o mesmo sinal de "selecionado" do resto da
   tela (aba ativa, cartao do recorte).

   O texto leva !important porque o tema escuro pinta com `color: $primary
   !important` todo botao outline de grupo (dark-layout.scss, .btn-group-toggle):
   sem isso o ativo virava um bloco laranja com texto laranja, sem rotulo.
   --------------------------------------------------------------------------- */
.kpi-tree__seg ::v-deep .btn.active:not(.disabled),
.kpi-tree__seg ::v-deep .btn:not(:disabled):not(.disabled).active {
  background-color: #f26237;
  border-color: #f26237;
  color: #fff !important;
  box-shadow: none;
}

/* ---------------------------------------------------------------------------
   LOCALIZAR
   --------------------------------------------------------------------------- */
.kpi-tree__find {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  width: 250px;
  height: 30px;
  padding: 0 0.3rem 0 0.6rem;
  border: 1px solid var(--kpi-input-border, #d8d6de);
  border-radius: 0.357rem;
  background: var(--kpi-input-bg, #fff);
  transition: border-color 160ms ease, box-shadow 160ms ease;
}

.kpi-tree__find:focus-within {
  border-color: #f26237;
  box-shadow: 0 3px 10px 0 rgba(242, 98, 55, 0.15);
}

.kpi-tree__find-icon {
  flex: 0 0 auto;
  color: var(--kpi-ink-muted, #b9b9c3);
}

.kpi-tree__find-input {
  flex: 1 1 auto;
  min-width: 0;
  height: 100%;
  padding: 0 0.25rem;
  border: 0;
  outline: none;
  background: transparent;
  font-size: 0.857rem;
  color: inherit;
}

.kpi-tree__find-count {
  flex: 0 0 auto;
  font-size: 0.75rem;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
  color: var(--kpi-ink-muted, #b9b9c3);
}

.kpi-tree__find-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 22px;
  height: 22px;
  padding: 0;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: inherit;
  cursor: pointer;
}

.kpi-tree__find-btn:hover:not(:disabled) {
  background: var(--kpi-chip-bg, #f3f2f7);
}

.kpi-tree__find-btn:disabled {
  opacity: 0.35;
  cursor: default;
}

/* ---------------------------------------------------------------------------
   EXIBICAO — o menu da barra da tabela.
   --------------------------------------------------------------------------- */
.kpi-tree__exib ::v-deep .kpi-tree__exib-form {
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  width: 270px;
  padding: 0.85rem 1rem 1rem;
}

.kpi-tree__exib-title {
  display: flex;
  align-items: center;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--kpi-ink-muted, #b9b9c3);
}

.kpi-tree__exib-label {
  margin: 0 0 -0.35rem;
  font-size: 0.8rem;
  font-weight: 500;
}

.kpi-tree__exib-sep {
  height: 1px;
  background: var(--kpi-line, #ebe9f1);
}

// O TRILHO DE COMPONENTES OCULTOS
//
// Quatro dos blocos vem desligados por padrao. Sem o trilho, a unica forma de
// descobrir que existem e abrir o painel de Componentes -- que so quem ja sabe
// procura. As chips sao tracejadas de proposito: marcam ausencia, nao estado.
.kpi-tree__rail {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.4rem;
  padding: 0.6rem 0.75rem;
  border-top: 1px solid var(--kpi-line, #ebe9f1);
}

.kpi-tree__rail-label {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--kpi-ink-muted, #b9b9c3);
  margin-right: 0.25rem;
}

.kpi-tree__rail-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.76rem;
  color: var(--kpi-ink-muted, #82868b);
  border: 1px dashed var(--kpi-line-strong, #d5d3de);
  border-radius: 20px;
  padding: 0.15rem 0.6rem;
}

.kpi-tree__rail-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex: 0 0 auto;
}

.kpi-tree__rail-count {
  color: var(--kpi-ink-muted, #b9b9c3);
}

.kpi-tree__rail-cta {
  margin-left: auto;
  background: none;
  border: 0;
  padding: 0;
  font-size: 0.76rem;
  color: #f26237;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}
.kpi-tree__toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.75rem 1rem;
  flex-wrap: wrap;
}

/* As duas classes existiam so no template, sem regra nenhuma -- o rotulo era
   texto solto dentro do flex. Dava 1,3px de desvio entre o centro de "Abrir
   ate" e o centro do grupo de botoes, porque o span se centrava pela propria
   caixa de linha e nao pela altura do botao. Um flex explicito com a mesma
   altura resolve, e de quebra o `gap` para de depender do espaco entre tags. */
.kpi-tree__toolbar-left,
.kpi-tree__toolbar-right {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.kpi-tree__level-label {
  display: inline-flex;
  align-items: center;
  align-self: stretch;
  margin-right: -0.25rem;
  line-height: 1;
  white-space: nowrap;
}

.kpi-tree__hint {
  font-size: 0.786rem;
  color: var(--kpi-ink-muted, #b9b9c3);
}

.kpi-tree__viewport {
  overflow: auto;
  position: relative;
}

.kpi-tree__table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 0.857rem;
}

/* ---------------------------------------------------------------------------
   A faixa de macrocomponente.

   Tres linhas grudam no topo, nesta ordem: faixa, rotulos, total. Cada uma
   ancora na altura MEDIDA da anterior e nao num valor cravado, porque a altura
   muda com zoom, com a fonte do sistema e com o padding do celular.
   --------------------------------------------------------------------------- */
.kpi-tree__band {
  position: sticky;
  top: 0;
  z-index: 6;
  padding: 0.3rem 0.75rem;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  text-align: center;
  white-space: nowrap;
  background: var(--band-tint, transparent);
  color: var(--band-ink, inherit);
  border-bottom: 2px solid var(--band-base, transparent);
}

/* Dois seletores de proposito, e nao por estilo. Esta celula carrega TAMBEM a
   classe .kpi-tree__cell--identity, que 130 linhas abaixo declara `z-index: 1`
   para o CORPO da tabela. As duas regras empatam em (0,1,0) e a de baixo ganha:
   medido no navegador, esta celula computava z-index 1 em vez de 7.
   Empatada com o corpo, e como <tbody> vem depois de <thead> no DOM, as linhas
   pintavam POR CIMA do cabecalho enquanto rolavam -- so na coluna da esquerda,
   que e a unica em que a faixa divide classe com o corpo. */
.kpi-tree__band.kpi-tree__band--identity {
  left: 0;
  z-index: 7;
  background: var(--kpi-tree-head-bg, #f3f2f7);
  border-bottom-color: var(--kpi-line, #ebe9f1);
}

/* NO ESCURO A FAIXA INVERTE.
   Os tints do tema claro sao pasteis quase brancos: sobre o card escuro viram
   listras berrantes que puxam o olho para o cabecalho em vez dos numeros. Aqui
   a faixa some para o fundo do cabecalho e quem carrega a identidade do grupo e
   o TEXTO, na cor viva -- que no claro seria clara demais para ler sobre o tint
   e aqui e exatamente a que tem contraste.

   Esta regra mora no componente, e nao no bloco .dark-layout de style.scss,
   porque o estilo com escopo acrescenta [data-v-*] ao seletor e empata em
   especificidade com uma regra global de mesma forma -- medido: a versao em
   style.scss nao pegava, o navegador seguia com o tint claro. `body.dark-layout`
   aqui desempata. */
body.dark-layout .kpi-tree__band {
  background: var(--kpi-tree-head-bg, #343d55);
  /* --band-ink-dark, e nao --band-base: o base e a cor viva do tema claro, e
     duas delas nao sobrevivem aqui. #3a4dc1 (Momento X) sobre #343d55 e
     praticamente o mesmo tom -- a faixa inteira sumia. O inkDark e o mesmo
     matiz clareado ate passar de 4.5:1. Ver kpiColumns.js. */
  color: var(--band-ink-dark, #b4b7bd);
  /* O filete carrega a identidade junto com o texto, entao segue a mesma cor.
     Antes ficava no --band-base cru e virava um risco escuro invisivel. */
  border-bottom-color: var(--band-ink-dark, transparent);
}

body.dark-layout .kpi-tree__band--identity {
  color: transparent;
  border-bottom-color: rgba(255, 255, 255, 0.08);
}

.kpi-tree__th {
  position: sticky;
  /* -1px de proposito: encostar exato depende de a medida bater com o pixel
     real, e quando sobra a folga vira janela transparente por onde a linha do
     corpo aparece. Sobrepor 1px e sempre seguro -- a faixa tem z-index maior
     (6/7 contra 5/6), entao ela cobre a sobra. */
  top: calc(var(--kpi-tree-band-h, 24px) - 1px);
  /* Escada de empilhamento: cabecalho (5/6) acima da linha de total (3/4), que
     fica acima do corpo (0/1). Sem isso a coluna fixa do corpo passa por cima
     da linha de total ao rolar na horizontal. */
  z-index: 5;
  background: var(--kpi-tree-head-bg, #f3f2f7);
  padding: 0.6rem 0.75rem;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
}

.kpi-tree__th--metric {
  text-align: right;
}

.kpi-tree__cell {
  padding: 0 0.75rem;
  white-space: nowrap;
  border-bottom: 1px solid var(--kpi-line, rgba(34, 41, 47, 0.06));
}

.kpi-tree__cell--metric {
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.kpi-tree__cell--openable {
  cursor: pointer;
}

/* O sublinhado vive no <span>, nao na <td>: numa celula alinhada a direita ele
   atravessaria o padding inteiro e ficaria descolado do numero. */
.kpi-tree__cell--openable:hover .kpi-tree__figure {
  color: #f26237;
  text-decoration: underline;
  text-underline-offset: 3px;
}

/* Solido pelo mesmo motivo do hover da linha: a coluna fixa tambem abre gaveta,
   e um fundo translucido nela deixaria ver as colunas rolando por baixo. */
.kpi-tree__row:hover .kpi-tree__cell--openable:hover {
  background: var(--kpi-tree-cell-hover-bg, #fdefe9);
}

/* Zero nao abre gaveta, e diz isso antes do clique: some do primeiro plano em
   vez de ficar competindo com os numeros que valem alguma coisa. */
.kpi-tree__figure--zero {
  color: var(--kpi-tree-zero, #d5d3de);
}

/* As familias. No tema escuro os tints claros somem, entao la todas caem no
   fundo translucido de --kpi-tree-role-bg e so a COR do texto separa. */
.kpi-tree__role--franqueado {
  background: var(--kpi-tree-role-bg, #e9ebf8);
  color: var(--kpi-tree-role-fg-franqueado, #3a4dc1);
}

.kpi-tree__role--fundador {
  background: var(--kpi-tree-role-bg, #e7f9ef);
  color: var(--kpi-tree-role-fg-fundador, #197b44);
}

.kpi-tree__role--pn,
.kpi-tree__role--outro {
  background: var(--kpi-tree-role-bg, #f3f2f7);
  color: var(--kpi-tree-role-fg, #82868b);
}

/* Zero manda: um total zerado nao e "bom", e ausencia. Por isso esta regra vem
   DEPOIS das semanticas e as sobrescreve. */
.kpi-tree__figure--total {
  font-weight: 600;
  color: var(--kpi-tree-verde, #197b44);
}

.kpi-tree__figure--alto {
  font-weight: 500;
  color: var(--kpi-tree-verde, #197b44);
}

.kpi-tree__figure--baixo {
  font-weight: 500;
  color: var(--kpi-tree-vermelho, #d31a1b);
}

.kpi-tree__figure--zero.kpi-tree__figure--total,
.kpi-tree__figure--zero.kpi-tree__figure--alto,
.kpi-tree__figure--zero.kpi-tree__figure--baixo {
  font-weight: inherit;
  color: var(--kpi-tree-zero, #d5d3de);
}

/* A coluna de identificação é o eixo da árvore: ela fica, o resto rola. */
.kpi-tree__cell--identity {
  position: sticky;
  left: 0;
  z-index: 1;
  background: var(--kpi-tree-cell-bg, #fff);
  text-align: left;
  font-weight: 400;
  min-width: 260px;
  max-width: 340px;
}

.kpi-tree__th.kpi-tree__cell--identity {
  z-index: 6;
  background: var(--kpi-tree-head-bg, #f3f2f7);
}

.kpi-tree__indent {
  display: inline-block;
  vertical-align: middle;
}

.kpi-tree__toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  margin-right: 0.25rem;
  border: 0;
  background: transparent;
  color: inherit;
  vertical-align: middle;
}

.kpi-tree__toggle--leaf {
  pointer-events: none;
}

.kpi-tree__chevron {
  transition: transform 180ms cubic-bezier(0.22, 1, 0.36, 1);
}

.kpi-tree__chevron--open {
  transform: rotate(90deg);
}

.kpi-tree__outline {
  display: inline-block;
  margin-right: 0.4rem;
  font-size: 0.714rem;
  font-variant-numeric: tabular-nums;
  color: var(--kpi-ink-muted, #b9b9c3);
  vertical-align: middle;
}

.kpi-tree__switch {
  display: inline-block;
  vertical-align: middle;
}

.kpi-tree__name {
  display: inline-block;
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}

.kpi-tree__count {
  margin-left: 0.4rem;
  vertical-align: middle;
}

.kpi-tree__shimmer {
  display: inline-block;
  height: 10px;
  border-radius: 4px;
  background: linear-gradient(90deg, var(--kpi-skeleton-a, rgba(34, 41, 47, 0.06)) 25%, var(--kpi-skeleton-b, rgba(34, 41, 47, 0.12)) 37%, var(--kpi-skeleton-a, rgba(34, 41, 47, 0.06)) 63%);
  background-size: 400% 100%;
  animation: kpi-tree-shimmer 1.4s ease infinite;
  vertical-align: middle;
}

.kpi-tree__shimmer--metric {
  margin-left: auto;
}

@keyframes kpi-tree-shimmer {
  0% { background-position: 100% 50%; }
  100% { background-position: 0 50%; }
}

@media (prefers-reduced-motion: reduce) {
  .kpi-tree__shimmer {
    animation: none;
  }
}

/* A produção própria do líder, ao lado do subtotal da rede. Discreta de
   propósito: é contexto, não a leitura principal. */
/* A revelação do acordeão: curta, escalonada, e só nas filhas recém-abertas. */
.kpi-tree__row--revealing .kpi-tree__cell,
.kpi-tree__row--revealing .kpi-tree__cell--identity {
  animation: kpi-tree-reveal 260ms cubic-bezier(0.22, 1, 0.36, 1) both;
  animation-delay: calc(var(--kpi-reveal-index, 0) * 28ms);
}

@keyframes kpi-tree-reveal {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }

  to {
    opacity: 1;
    transform: none;
  }
}

/* O HOVER PEGA A LINHA INTEIRA, nome incluido.
   Antes a coluna de nomes ficava de fora -- ela e sticky e precisa de fundo
   opaco, e o hover era translucido --, e numa linha de 30 colunas o olho
   perdia a linha exatamente onde ela comeca. Cores SOLIDAS resolvem as duas
   coisas: as colunas fixas acendem junto e nada aparece por baixo delas. */
.kpi-tree__row:hover .kpi-tree__cell {
  background: var(--kpi-tree-row-hover-bg, #f8f8fa);
}

.kpi-tree__row--found .kpi-tree__cell {
  background: var(--kpi-tree-row-found-bg, #fff6f2);
}

.kpi-tree__row--found .kpi-tree__cell--identity {
  box-shadow: inset 3px 0 0 #f26237;
}

.kpi-tree__row--current .kpi-tree__cell {
  background: var(--kpi-tree-row-current-bg, #fde6dc);
}

.kpi-tree__row--selected .kpi-tree__cell {
  background: var(--kpi-tree-row-selected-bg, #fdebe4);
}

.kpi-tree__spacer td {
  padding: 0;
  border: 0;
}

.kpi-tree__empty td {
  padding: 2.5rem 1rem;
  text-align: center;
  color: var(--kpi-ink-muted, #b9b9c3);
}

/* O chip de cargo, colorido pela FAMILIA — ver familiaDoCargo(). Os tints sao
   os mesmos dos macrocomponentes, para a tela ter uma paleta so. */
.kpi-tree__role {
  display: inline-block;
  margin-left: 0.4rem;
  padding: 0 0.35rem;
  border-radius: 0.25rem;
  font-size: 0.643rem;
  font-weight: 600;
  line-height: 1.5;
  letter-spacing: 0.04em;
  color: var(--kpi-tree-role-fg, #82868b);
  background: var(--kpi-tree-role-bg, #f3f2f7);
  vertical-align: middle;
}

/* O chip de FRANQUIA, irmao do de cargo mas sem cor de familia: ele nao
   classifica ninguem, so diz de QUE LINHA aquele numero e. Contorno em vez de
   fundo cheio para nao competir com o cargo, que esta ao lado. */
.kpi-tree__franchise {
  display: inline-block;
  margin-left: 0.4rem;
  padding: 0 0.35rem;
  border-radius: 0.25rem;
  font-size: 0.643rem;
  font-weight: 600;
  line-height: 1.5;
  letter-spacing: 0.04em;
  color: var(--kpi-tree-franchise-fg, #a8aab3);
  background: var(--kpi-tree-franchise-bg, #fbfbfc);
  border: 1px solid var(--kpi-tree-franchise-br, #ebe9f1);
  vertical-align: middle;
}

@media (prefers-reduced-motion: reduce) {
  .kpi-tree__chevron {
    transition: none;
  }

  .kpi-tree__row--revealing .kpi-tree__cell,
  .kpi-tree__row--revealing .kpi-tree__cell--identity {
    animation: none;
  }
}

/* ---------------------------------------------------------------------------
   Tela estreita.

   A tabela continua sendo tabela — virar cartão empilhado perderia a
   comparação entre linhas, que é a razão de a tela existir. O que muda é o
   peso: a coluna de identificação encolhe e solta a âncora, o cargo sai (já
   está na gaveta), e o corpo ganha respiro para o polegar alcançar o scroll.
   --------------------------------------------------------------------------- */
@media (max-width: 767.98px) {
  /* A identidade do corpo perde o sticky horizontal no celular (regra mais
     abaixo). A linha de total mantem o VERTICAL: ela e a leitura principal e
     nao pode rolar para fora. */
  .kpi-tree__total > .kpi-tree__cell--identity {
    position: sticky;
    left: auto;
  }

  /* O CABECALHO precisa da mesma excecao, e pelo mesmo motivo. A classe
     kpi-tree__cell--identity nao esta so no corpo: esta tambem na faixa de
     grupos (template, linha 83) e na celula CONSULTOR (linha 100). A regra
     `position: static` la embaixo foi escrita para o corpo, mas empata em
     especificidade com .kpi-tree__band e .kpi-tree__th e vem depois no arquivo
     -- entao ganha, e o cabecalho rola para fora da tela no celular.
     left: auto preserva a intencao original (soltar a ancora HORIZONTAL) e
     devolve so o grude vertical. */
  .kpi-tree__bands > .kpi-tree__cell--identity,
  .kpi-tree__th.kpi-tree__cell--identity {
    position: sticky;
    left: auto;
  }

  .kpi-tree__toolbar {
    padding: 0.6rem 0.75rem;
    gap: 0.5rem;
  }

  .kpi-tree__toolbar-right {
    width: 100%;
  }

  .kpi-tree__hint {
    flex-basis: 100%;
  }

  .kpi-tree__cell--identity {
    min-width: 168px;
    max-width: 200px;
    /* Sem sticky no celular: a coluna fixa comeria metade da largura útil e
       sobraria uma fresta para os números, que é o que se veio ver. */
    position: static;
  }

  .kpi-tree__name {
    max-width: 110px;
  }

  .kpi-tree__role,
  .kpi-tree__franchise {
    display: none;
  }

  .kpi-tree__cell,
  .kpi-tree__th {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
}
</style>
